var _rect, _rect2, _path, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 25,
    height: 25,
    rx: 11.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5181 12.1C15.1393 12.1 14.793 12.314 14.6236 12.6528L14.2 13.5H19.8L19.3764 12.6528C19.207 12.314 18.8608 12.1 18.482 12.1H15.5181ZM11.4 15.2C11.4 14.6477 11.8477 14.2 12.4 14.2H21.6C22.1523 14.2 22.6 14.6477 22.6 15.2V20.9C22.6 21.4523 22.1523 21.9 21.6 21.9H12.4C11.8477 21.9 11.4 21.4523 11.4 20.9V15.2ZM17 18.6C17.4971 18.6 17.9 18.197 17.9 17.7C17.9 17.2029 17.4971 16.8 17 16.8C16.503 16.8 16.1 17.2029 16.1 17.7C16.1 18.197 16.503 18.6 17 18.6ZM17 19.8C18.1598 19.8 19.1 18.8598 19.1 17.7C19.1 16.5402 18.1598 15.6 17 15.6C15.8402 15.6 14.9 16.5402 14.9 17.7C14.9 18.8598 15.8402 19.8 17 19.8Z",
    fill: "#2A2D32"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 25,
    height: 25,
    rx: 11.5,
    stroke: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera_icon.330888f26d20ac23d20a415a8bff52a8.svg";
export { ForwardRef as ReactComponent };